import { render, staticRenderFns } from "./EditFundingRounds.vue?vue&type=template&id=f7d1c970&scoped=true&"
import script from "./EditFundingRounds.vue?vue&type=script&lang=js&"
export * from "./EditFundingRounds.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f7d1c970",
  null
  
)

export default component.exports